// A location the customer can book at: one the lookup returned with an
// address. The location lists only show these, and the journey hands over when
// there are none, so both read the same rule from here.
export const isBookableLocation = (location) => Boolean(location?.address);

export const selectHasBookableLocations = (state) =>
  (state.clientApiJourney?.location?.list ?? []).some(isBookableLocation);

// The clinic the booking targets: the one whose slot the user picked. A nearby
// clinic's slot carries its own locationId, so the booking follows the picked
// slot rather than the clinic chosen on the location screen. When the picked
// slot belongs to the chosen clinic (or none is picked), this returns the chosen
// clinic object itself, so the store journey and solar are unchanged.
export const selectBookingLocation = (state) => {
  const location = state.clientApiJourney?.location;
  const selected = location?.selected;
  const pickedLocationId =
    state.clientApiJourney?.appointment?.selectedSlot?.locationId;

  if (!pickedLocationId || pickedLocationId === selected?.id) {
    return selected;
  }

  return (
    (location?.list ?? []).find(
      (candidate) => candidate.id === pickedLocationId
    ) ?? selected
  );
};
